<template>
  <div class="grouped">
    <div
      v-if="product?.items"
      class="grouped__product-container typed-product__product-container"
    >
      <div class="grouped__products-heading typed-product__products-heading">
        <span>{{ $t('This look contains') }}</span>
        <ProductToggleWishlist
          class="add-to-cart__wishlist-toggle button button--link button--icon-only"
          :product="product"
        />
      </div>

      <template
        v-for="item in product.items"
        :key="item"
      >
        <ProductGroupedItem
          v-if="item?.product"
          :item="item"
          @selected="collect"
        />
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MagentoGroupedProduct, MagentoCartItemInput } from '~/app/types/magento'

export interface Props {
  product: MagentoGroupedProduct
}

defineProps<Props>()

const emit = defineEmits<{
  selected: Record<string, MagentoCartItemInput>
}>()

const selectedItems = ref<Record<string, MagentoCartItemInput>>({})

watch(selectedItems, () => {
  emit('selected', selectedItems.value)
})

const collect = (item: Record<string, MagentoCartItemInput>) => {
  selectedItems.value = {
    ...selectedItems.value,
    ...item,
  }
}
</script>

<style src="~layers/app/components/Product/Grouped.css" />
